import { CSSProperties } from "react";

export const selectStyle = {
  control: (base: CSSProperties) => ({
    ...base,
    border: 0,
    boxShadow: 0,
    paddingRight: 0
  }),
  dropdownIndicator: (base: CSSProperties) => ({
    ...base,
    padding: 0,
    margin: 0,
  }),
  input: (base: CSSProperties) => ({
    ...base,
    padding: 0,
    margin: 0,
  }),
  option: (base: CSSProperties) => ({
    ...base,
    paddingLeft: 5,
    textAlign: "left"
  }),
};
